
const DisplayOnlyTextField = (props) => {
    return (
        <div className={props.class}>
            <label className='bold'>{props.label} {props.symbolLabel && <span className={props.symbolLabelClass}>{props.symbolLabel}</span>}</label>
            <span id={props.id} name={props.name}>{props.value}</span>
            <span className='error'>{props.validationErrors}</span>
        </div>
    );
};

export default DisplayOnlyTextField;